module.exports = __webpack_public_path__ + "img/Atelier_5.3fc43412.jpg";